const emailValidator = (value) => {
    const validate = () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    const errorMessage = "Please enter a valid email address.";
    return { validate, errorMessage };
};

export default emailValidator;
